export default __webpack_public_path__ + "static/media/34.1c1bf5c0.svg";